interface Properties {
  width?: number;
  height?: number;
  color?: string;
}

/**
 * Vector recreation of the Figma "Blocks" nav-tab icon (a 2-column grid of
 * rounded squares). The source Figma asset is a small flattened raster image;
 * this traces the same shape as crisp SVG so it stays sharp at any size.
 */
const FigmaBlocksIcon = ({ width = 16, height = 16, color = '#121826' }: Properties) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M0,0 H5 A2,2 0 0 1 7,2 V4 H0 Z' fill={color} />
      <path d='M0,6 H7 V10 H0 Z' fill={color} />
      <path d='M9,6 H14 A2,2 0 0 1 16,8 V10 H9 Z' fill={color} />
      <path d='M0,12 H7 V16 H2 A2,2 0 0 1 0,14 Z' fill={color} />
      <path d='M9,12 H16 V14 A2,2 0 0 1 14,16 H9 Z' fill={color} />
    </svg>
  );
};

export default FigmaBlocksIcon;
